import { platformApiFetch } from '@/services/platformApi/client';
import type { Provider } from '@/types/supabase';
import type { AreaData } from '@/services/areaService';
import type { CategoryData } from '@/services/categoryService';

export async function getPlatformProviders(): Promise<Provider[]> {
  return platformApiFetch<Provider[]>('/v1/providers');
}

export async function getPlatformProvider(identifier: string, options?: { includeUnapproved?: boolean }): Promise<Provider | null> {
  const query = options?.includeUnapproved ? '?includeUnapproved=true' : '';
  return platformApiFetch<Provider | null>(`/v1/providers/${encodeURIComponent(identifier)}${query}`);
}

export async function getPlatformFeaturedProviders(limit: number = 6): Promise<Provider[]> {
  return platformApiFetch<Provider[]>(`/v1/providers/featured?limit=${limit}`);
}

export async function getPlatformCategories(): Promise<CategoryData[]> {
  return platformApiFetch<CategoryData[]>('/v1/categories');
}

export async function getPlatformAreas(): Promise<AreaData[]> {
  return platformApiFetch<AreaData[]>('/v1/areas');
}